import { Engine, Scene, ArcRotateCamera, Vector3, HemisphericLight, Mesh, MeshBuilder,
    ActionManager, ExecuteCodeAction, Color3, Color4, Material, StandardMaterial, Axis, Animation} from "@babylonjs/core";

import {Track} from "./track"

class Cart {
    box: Mesh;
    track: Track;
    scene: Scene;
    depth: number;
    wheelRadius: number;
    width: number;
    height: number;

    constructor(scene, x, y, track) {
        const cartFactor = 0.75;
        this.height = track.height*cartFactor;
        this.width = track.width*cartFactor;
        this.depth = 0.1;
        this.track = track;
        this.scene = scene;
        this.wheelRadius = 0.1;

        let cartColor = new Color3(0.0, 0.5, 1.0);

        let cartMat: StandardMaterial = new StandardMaterial('cart', scene);
        cartMat.diffuseColor = cartColor;

        this.box = MeshBuilder.CreateBox("cartBody", {height: this.height, width: this.width, depth: this.depth}, scene);
        this.box.position.x = 0;
        this.box.position.y = 0;
        this.box.position.z = this.getZ();

        // this.box.visibility = 0.5;

        this.box.parent = track.box;
        this.box.material = cartMat;
        
        const wheelMaterial = new StandardMaterial("wheelMaterial", scene);
        wheelMaterial.diffuseColor = new Color3(0.2, 0.2, 0.2);

        let createWheel = (name, positionX, positionZ, wheelWidth=this.track.railWidth) => {
            const wheel = MeshBuilder.CreateCylinder(name, {
                height: wheelWidth,
                diameter: 2*this.wheelRadius
            }, scene);
            // wheel.rotation.z = Math.PI / 2;
            wheel.position.y = positionZ;
            wheel.position.x = positionX;
            wheel.position.z = -2*this.wheelRadius;
            wheel.material = wheelMaterial;
            wheel.parent = this.box;
            return wheel;
        };

        // Add four wheels
        let wheelX = this.width/2 - this.wheelRadius;
        let wheelZ = this.track.railSpacing/2;

        const frontLeftWheel = createWheel("frontLeftWheel", wheelX, wheelZ);
        const frontRightWheel = createWheel("frontRightWheel", -wheelX, wheelZ);
        const backLeftWheel = createWheel("backLeftWheel", -wheelX, -wheelZ);
        const backRightWheel = createWheel("backRightWheel", wheelX, -wheelZ);
    }

    getZ() {
        return (this.depth + this.track.depth/2 + this.track.railWidth + 2*this.wheelRadius);
    }

    async sleep(ms: number): Promise<void> {
        return new Promise((resolve) => setTimeout(resolve, ms));
    }

    async moveToTrack(track) {
        this.box.setParent(track.box);

        let FPS = 60;
        let secondsToCompleteAnimation = 1;
        let framesToCompleteAnimation = secondsToCompleteAnimation * FPS;

        const animation = new Animation(
            "moveAnimation",
            "position",
            FPS,
            Animation.ANIMATIONTYPE_VECTOR3,
            Animation.ANIMATIONLOOPMODE_CONSTANT
        );

        const keys = [
            { frame: 0, value: this.box.position },
            { frame: framesToCompleteAnimation, value: new Vector3(0, 0, this.getZ()) }
        ];

        animation.setKeys(keys);
        this.box.animations = [];
        this.box.animations.push(animation);

        await new Promise<void>((resolve) => {
            this.scene.beginAnimation(this.box, 0, framesToCompleteAnimation, false, undefined, () => {
                globalThis.world.cart.track = track;
                resolve();
            });
        });
        console.log("moveToTrack done");
    }
}

export {Cart};